/* unplugin-vue-components disabled */import { render } from "./E808B2BtnGroup.vue?vue&type=template&id=65d59a4a&scoped=true"
import script from "./E808B2BtnGroup.vue?vue&type=script&lang=js"
export * from "./E808B2BtnGroup.vue?vue&type=script&lang=js"

import "./E808B2BtnGroup.vue?vue&type=style&index=0&id=65d59a4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d59a4a"]])

export default __exports__